<template>
  <div class="card">
    <div v-if="title" class="card-header">
      {{ title }}
    </div>

    <div :class="{ 'card-body': true, 'p-0': noPadding }">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',

  props: {
    noPadding: { type: Boolean, default: false },
    title: { type: String, default: null }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Card.vue